import { render, staticRenderFns } from "./CardActivated.vue?vue&type=template&id=6c1e89d9&"
import script from "./CardActivated.vue?vue&type=script&lang=js&"
export * from "./CardActivated.vue?vue&type=script&lang=js&"
import style0 from "./CardActivated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports